// SPDX-License-Identifier: AGPL-3.0-or-later

import type {
	GlassLook,
	GlassPalette,
	GlassPreset,
	GlassThemeSettings,
	GlassTone,
} from '@app/features/theme/state/GlassTheme';
import GlassTheme from '@app/features/theme/state/GlassTheme';

export function update(partial: Partial<GlassThemeSettings>): boolean {
	GlassTheme.update(partial);
	return true;
}

export function applyPreset(preset: GlassPreset): boolean {
	GlassTheme.applyPreset(preset);
	return true;
}

export function reset(): boolean {
	GlassTheme.reset();
	return true;
}

export function applyPalette(palette: GlassPalette): boolean {
	GlassTheme.applyPalette(palette);
	return true;
}

export function applyLook(look: GlassLook): boolean {
	GlassTheme.applyLook(look);
	return true;
}

export function setTone(tone: GlassTone): boolean {
	GlassTheme.setTone(tone);
	return true;
}
